"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: user/family-unauthenticated-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fuser%2Ffamily-unauthenticated-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.FamilyUnauthenticatedServiceClient = exports.LookupFamilyInviteResponse = exports.LookupFamilyInviteRequest = exports.UnauthenticatedFamilyInviteInviter = exports.UnauthenticatedFamilyInvite = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const legal_name_1 = require("../common/legal-name");
const protobufPackage = 'com.step.user.proto';
function createBaseUnauthenticatedFamilyInvite() {
    return { inviter: exports.UnauthenticatedFamilyInviteInviter.fromPartial({}) };
}
exports.UnauthenticatedFamilyInvite = {
    fromJSON(object) {
        const message = {
            inviter: isSet(object.inviter)
                ? exports.UnauthenticatedFamilyInviteInviter.fromJSON(object.inviter)
                : exports.UnauthenticatedFamilyInviteInviter.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.inviter !== undefined) {
            obj.inviter = exports.UnauthenticatedFamilyInviteInviter.toJSON(message.inviter);
        }
        return obj;
    },
    create(base) {
        return exports.UnauthenticatedFamilyInvite.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUnauthenticatedFamilyInvite();
        message.inviter = (object.inviter !== undefined && object.inviter !== null)
            ? exports.UnauthenticatedFamilyInviteInviter.fromPartial(object.inviter)
            : exports.UnauthenticatedFamilyInviteInviter.fromPartial({});
        return message;
    },
};
function createBaseUnauthenticatedFamilyInviteInviter() {
    return { legalName: legal_name_1.LegalName.fromPartial({}), pictureUrl: '', isUnder13: false };
}
exports.UnauthenticatedFamilyInviteInviter = {
    fromJSON(object) {
        const message = {
            legalName: isSet(object.legalName)
                ? legal_name_1.LegalName.fromJSON(object.legalName)
                : legal_name_1.LegalName.fromPartial({}),
            isUnder13: isSet(object.isUnder13) ? globalThis.Boolean(object.isUnder13) : false,
        };
        if (isSet(object.pictureUrl)) {
            message.pictureUrl = globalThis.String(object.pictureUrl);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.legalName !== undefined) {
            obj.legalName = legal_name_1.LegalName.toJSON(message.legalName);
        }
        if (message.pictureUrl !== undefined && message.pictureUrl !== '') {
            obj.pictureUrl = message.pictureUrl;
        }
        if (message.isUnder13 !== false) {
            obj.isUnder13 = message.isUnder13;
        }
        return obj;
    },
    create(base) {
        return exports.UnauthenticatedFamilyInviteInviter.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUnauthenticatedFamilyInviteInviter();
        message.legalName = (object.legalName !== undefined && object.legalName !== null)
            ? legal_name_1.LegalName.fromPartial(object.legalName)
            : legal_name_1.LegalName.fromPartial({});
        message.pictureUrl = object.pictureUrl ?? '';
        message.isUnder13 = object.isUnder13 ?? false;
        return message;
    },
};
function createBaseLookupFamilyInviteRequest() {
    return { inviteId: '' };
}
exports.LookupFamilyInviteRequest = {
    fromJSON(object) {
        const message = {
            inviteId: isSet(object.inviteId) ? globalThis.String(object.inviteId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.inviteId !== '') {
            obj.inviteId = message.inviteId;
        }
        return obj;
    },
    create(base) {
        return exports.LookupFamilyInviteRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLookupFamilyInviteRequest();
        message.inviteId = object.inviteId ?? '';
        return message;
    },
};
function createBaseLookupFamilyInviteResponse() {
    return { invite: undefined };
}
exports.LookupFamilyInviteResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.invite)) {
            message.invite = exports.UnauthenticatedFamilyInvite.fromJSON(object.invite);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.invite !== undefined) {
            obj.invite = exports.UnauthenticatedFamilyInvite.toJSON(message.invite);
        }
        return obj;
    },
    create(base) {
        return exports.LookupFamilyInviteResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLookupFamilyInviteResponse();
        message.invite = (object.invite !== undefined && object.invite !== null)
            ? exports.UnauthenticatedFamilyInvite.fromPartial(object.invite)
            : undefined;
        return message;
    },
};
/**
 * Family Unauthenticated Service API.
 *
 * Allows unauthenticated client to retrieve family invite
 */
class FamilyUnauthenticatedServiceClient {
    rpc;
    name = 'com.step.user.proto.FamilyUnauthenticatedService';
    type = rpc_1.ServiceType.UNAUTHENTICATED;
    path = '/family';
    methods = [{
            name: 'LookupFamilyInvite',
            requestType: exports.LookupFamilyInviteRequest,
            responseType: exports.LookupFamilyInviteResponse,
            authenticationOptions: undefined,
            adminTokenType: undefined,
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Looks up family invite given invite id
     */
    lookupFamilyInvite(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.FamilyUnauthenticatedServiceClient = FamilyUnauthenticatedServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=family-unauthenticated-service.js.map